export default function Footer() {

  return (
    <div className=" mb-4">

      <footer className="text-center text-lg-start text-muted" style={{ backgroundColor: '#000' }}>


{
  /*
  <div className="me-5 d-none d-lg-block">
            <span>Siguenos en nuestras redes sociales:</span>
          </div>

          <div>
            <a href="https://www.facebook.com/hseqinternationalsas" target="_blank" className="me-4 text-reset">
              <i className="fab fa-facebook-f"></i>
            </a>
            <a href="https://www.instagram.com/hseq_international/" target="_blank" className="me-4 text-reset">
              <i className="fab fa-instagram"></i>
            </a>
          </div>

  */
}
        <section className="d-flex justify-content-center  p-4 border-bottom">


        

        </section>

        <section className="">
          <div className="container text-center text-md-start mt-5">
            <div className="row mt-3">

              <div className="col-md-6 col-lg-6 col-xl-6 mx-auto mb-4">
                <h6 className="text-uppercase fw-bold mb-4">
                  <i className="fas fa-gem me-3"></i>SAOS ALTURAL SAS
                </h6>
                <p>
                  Se dedica a la  Asesoría, consultoría y  prestación de  servicios en salud ocupacional.
                </p>
              </div>




              <div className="col-md-6 col-lg-6 col-xl-6 mx-auto mb-md-0 mb-4" style={{ textAlign: 'center' }} >

                <h6 className="text-uppercase fw-bold mb-4">Contactenos</h6>
                <p><i className="fas fa-envelope me-3"></i> saosalturasas@gmail.com</p>
                <p><i className="fas fa-house me-3"></i>CL 26 SUR N° 27-31</p>
                <p><i className="fas fa-phone me-3"></i>+57 324 428 1598</p>
              </div>

            </div>

          </div>
        </section>



        <div className="text-center pt-4 pb-4 " style={{ backgroundColor: '#FFD302', color: '#000' }}>
          <p>
            © 2022 Copyright: <a style={{ textDecoration: 'none' }} className="text-reset fw-bold" href="https://multinet.com.co/">  Multinet Soluciones Digitales</a>
          </p>
        </div>
      </footer>
    </div>


  )


}